(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function() {
  // Save the last page visited (excluding cart and checkout pages)
  if (!window.location.pathname.includes('/cart') && 
      !window.location.pathname.includes('/checkout')) {
    sessionStorage.setItem('lastVisitedPage', window.location.href);
  }
  
  // If we arrived at cart from a product page, save the collection URL if exists
  if (window.location.pathname.includes('/cart') && 
      document.referrer && 
      document.referrer.includes('/products/') &&
      document.referrer.includes(window.location.hostname)) {
    
    // Check if the product URL contains a collection path
    const collectionMatch = document.referrer.match(/\/collections\/([^\/]+)\/products/);
    
    if (collectionMatch && collectionMatch[1]) {
      // Save the collection URL instead of the product page
      const collectionUrl = window.location.origin + '/collections/' + collectionMatch[1];
      sessionStorage.setItem('lastVisitedPage', collectionUrl);
    } else {
      // If no collection in URL, save the product page
      sessionStorage.setItem('lastVisitedPage', document.referrer);
    }
  }
  
  // Update the link on the cart page
  if (window.location.pathname.includes('/cart')) {
    document.addEventListener('DOMContentLoaded', function() {
      const continueLink = document.getElementById('continue-shopping-link');
      
      if (continueLink) {
        const lastPage = sessionStorage.getItem('lastVisitedPage');
        
        // If there's a saved page, update the href
        if (lastPage) {
          continueLink.href = lastPage;
        }
        // Otherwise, use document.referrer as fallback
        else if (document.referrer && 
                 document.referrer.includes(window.location.hostname) &&
                 !document.referrer.includes('/cart')) {
          continueLink.href = document.referrer;
        }
        // Otherwise, the link is already set to routes.collections_url from HTML
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function myFunction() {
    var checkBox = document.getElementById("myCheck");
    var text = document.getElementById("text");
    if (checkBox.checked == true){
      text.style.display = "block";
    } else {
       text.style.display = "none";
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      if (window.swCompactProductRail) window.swCompactProductRail.mount(productRecommendationsSection);
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    if (window.swCompactProductRail) window.swCompactProductRail.unmount(event.target);
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-approved-box-archive"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.swArchiveReady === 'true') return;
    const detailsList = Array.from(root.querySelectorAll('details.sw-approved-box-archive__details'));
    if (!detailsList.length) return;
    root.dataset.swArchiveReady = 'true';
    let active = null;

    function returnToSummary(details) {
      const summary = details.querySelector('summary');
      const savedScroll = Number(details.dataset.swSavedScroll || window.scrollY);
      if (summary) summary.focus({ preventScroll: true });
      window.scrollTo({ left: window.scrollX, top: savedScroll, behavior: 'auto' });
    }

    root.addEventListener('click', event => {
      const summary = event.target.closest && event.target.closest('summary');
      if (summary && summary.parentElement.matches('details.sw-approved-box-archive__details') && !summary.parentElement.open) {
        summary.parentElement.dataset.swSavedScroll = String(window.scrollY);
      }
      const closeButton = event.target.closest && event.target.closest('[data-sw-archive-close]');
      if (!closeButton) return;
      const details = closeButton.closest('details.sw-approved-box-archive__details');
      if (!details) return;
      event.preventDefault();
      details.open = false;
      if (active === details) {
        active = null;
        requestAnimationFrame(() => { returnToSummary(details); });
      }
    }, true);

    detailsList.forEach(details => {
      details.addEventListener('toggle', () => {
        if (details.open) {
          active = details;
          detailsList.forEach(other => { if (other !== details && other.open) other.open = false; });
          return;
        }
        if (active !== details) return;
        active = null;
        requestAnimationFrame(() => { returnToSummary(details); });
      });
    });

    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !active) return;
      event.preventDefault();
      const details = active;
      active = null;
      details.open = false;
      requestAnimationFrame(() => { returnToSummary(details); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sw-box-archive]').forEach(init);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', event => { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-approved-palette-shelf"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.swPaletteReady === 'true') return;
    const inputs = Array.from(root.querySelectorAll('input[type="radio"][name^="sw-palette-"]'));
    const panels = Array.from(root.querySelectorAll('[data-sw-palette-panel]'));
    if (!inputs.length || !panels.length) return;
    root.dataset.swPaletteReady = 'true';
    root.querySelector('[data-sw-palette-controls]').hidden = false;
    function select(value) {
      panels.forEach(panel => { panel.hidden = panel.dataset.swPalettePanel !== value; });
    }
    inputs.forEach(input => input.addEventListener('change', () => { if (input.checked) select(input.value); }));
    const selected = inputs.find(input => input.checked) || inputs[0];
    selected.checked = true;
    select(selected.value);
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-sw-palette-shelf]').forEach(init); }
  initAll(document);
  document.addEventListener('shopify:section:load', event => { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-product-discovery-tags-qa"]) return;
  try {
    
  function myFunction() {
    var checkBox = document.getElementById("myCheck");
    var text = document.getElementById("text");
    if (checkBox.checked == true){
      text.style.display = "block";
    } else {
       text.style.display = "none";
    }
  }

  } catch(e) { console.error(e); }
})();
})();
